import { ChangeEvent } from 'react';
import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { IconUserSquareRounded } from '@rossum/ui/icons/tabler';
import { Box, Checkbox, Stack, Typography } from '@rossum/ui/material';
import InfoPlaceholder from '../../../components/UI/InfoPlaceHolder';
import Loader from '../../Loader';
import Picker, { OptionT } from '../components/Picker';

type Props = {
  isSearched: boolean;
  onPick: (ids: Array<number>) => void;
  onSearch: (search: string) => void;
  options: Array<OptionT>;
  picked: Array<number>;
  usersLoaded: boolean;
  deletedUsersIdList: Array<number>;
};

const UserPicker = ({
  isSearched,
  options,
  picked,
  onPick,
  onSearch,
  usersLoaded,
  deletedUsersIdList: data,
}: Props) => {
  const intl = useIntl();

  return (
    <>
      <Picker
        titleId="containers.statistics.sidebar.title.users"
        options={options}
        isSearched={isSearched}
        onSearch={onSearch}
        onPick={onPick}
        dataCy="stats-select-all-users"
        picked={picked}
        noResultsPlaceholder={
          usersLoaded ? (
            <InfoPlaceholder
              icon={IconUserSquareRounded}
              title="containers.statistics.noUsers"
            />
          ) : (
            <Loader />
          )
        }
      />
      <Box
        sx={{ height: 100, p: 1 }}
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-end"
      >
        <Stack
          component="label"
          direction="row"
          spacing={3}
          alignItems="center"
          sx={{ cursor: 'pointer' }}
        >
          <Typography variant="body2">
            {intl.formatMessage({
              id: 'containers.statistics.sidebar.checkbox.deletedUsers',
            })}
          </Typography>
          <Checkbox
            size="small"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (data) {
                const newPicked = e.target.checked
                  ? R.unique([...picked, ...data])
                  : picked.filter(id => !data.includes(id));
                onPick(newPicked);
              }
            }}
            id="deleted-users"
            checked={data?.every(id => picked.includes(id)) ?? false}
          />
        </Stack>
      </Box>
    </>
  );
};

export default UserPicker;
